<script>
import AdminLayout from '@layouts/admin-main'
import { fetchConfig, updateConfig } from '@apis/admin/config'
import { mapState } from 'vuex'
import fromPairs from 'lodash/fromPairs'
import LangInput from '@components/admin/lang-input'

export default {
  components: { AdminLayout, LangInput },
  data() {
    return {
      config: null,
      loading: false,
    }
  },
  computed: {
    ...mapState('common', {
      constants: (state) => state.constants,
    }),
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      Promise.all([this.loadConfig()]).catch((e) =>
        this.$toasted.error(e.message)
      )
    },
    async loadConfig() {
      const { config } = await fetchConfig('service')
      this.config = config
    },
    handleUpdate() {
      this.loading = true
      this.$confirm('config_service.msg_save', 'config_service.msg_save', {
        type: 'warning',
      })
        .then(() => updateConfig('service', this.config))
        .then(() => this.loadConfig())
        .then(() =>
          this.$notify({
            title: this.$t('toasted_msg.title'),
            message: this.$t('admin.msg_save_success'),
            type: 'success',
          })
        )
        .catch((e) => (e === 'cancel' ? null : this.$toasted.error(e.message)))
        .finally(() => {
          this.loading = false
        })
    },
    fromPairs,
  },
  page: {
    title: 'Admin::ConfigService',
    meta: [{ name: 'description', content: 'Admin::ConfigService' }],
  },
}
</script>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';
</style>

<template>
  <AdminLayout>
    <h3 :class="$style.xeAdmin">{{ $t('admin_main.service') }}</h3>
    <div :class="$style.infoText">
      <p>{{ $t('admin.service_msg') }}</p>
    </div>
    <form
      v-if="config"
      v-loading="loading"
      action="./"
      method="get"
      @submit.prevent="handleUpdate"
    >
      <table :class="$style.rowTable" cellpadding="0">
        <colgroup>
          <col width="200" />
          <col width="35%" />
          <col width="200" />
          <col width="*" />
        </colgroup>
        <tbody>
          <tr>
            <th scope="col"
              ><div>{{ $t('admin.token_secret') }}</div></th
            >
            <td>
              <input
                v-model="config.token_secret"
                type="text"
                :class="[$style.inputTypeText, $style.fullWidth]"
              />
            </td>
            <th scope="col"
              ><div>{{ $t('admin.token_lifetime') }}</div></th
            >
            <td
              ><input
                v-model.number="config.token_lifetime"
                type="text"
                :class="[$style.inputTypeText, $style.w60, $style.tRight]"
              />
              {{ $t('config_service.second') }}</td
            >
          </tr>
          <tr>
            <th scope="col"
              ><div>{{ $t('admin.default_locale') }}</div></th
            >
            <td>
              <select v-model="config.default_locale">
                <option
                  v-for="val in [...constants.lang.locales]"
                  :key="val[1]"
                  :value="val[0]"
                  >{{ val[1] }}</option
                >
              </select>
            </td>
            <th scope="col"
              ><div>{{ $t('admin.support_locale') }}</div></th
            >
            <td>
              <label v-for="val in [...constants.lang.locales]" :key="val[0]">
                <input
                  v-model="config.support_locales"
                  name="support_locales"
                  type="checkbox"
                  :value="val[0]"
                />{{ val[1] }}
              </label>
            </td>
          </tr>
        </tbody>
      </table>
      <template v-for="val in config.terms">
        <h3 :key="`${val.type}-title`" :class="$style.xeAdmin">{{
          fromPairs(constants.service.term_types)[val.type]
        }}</h3>
        <table
          :key="`${val.type}-table`"
          :class="$style.rowTable"
          cellpadding="0"
        >
          <colgroup>
            <col width="200" />
            <col width="35%" />
            <col width="200" />
            <col width="*" />
          </colgroup>
          <tbody>
            <tr>
              <th scope="col"
                ><div>{{ $t('admin.page_display') }}</div></th
              >
              <td>
                <input
                  v-model="val.display"
                  type="checkbox"
                  true-value="Y"
                  false-value="N"
                />
              </td>
              <th scope="col"
                ><div>{{ $t('admin.use_signup') }}</div></th
              >
              <td>
                <input
                  v-model="val.use_signup"
                  type="checkbox"
                  true-value="Y"
                  false-value="N"
                />
                (<label
                  ><input
                    v-model="val.is_required"
                    type="checkbox"
                    true-value="Y"
                    false-value="N"
                  />
                  {{ $t('admin.is_required') }}</label
                >)
              </td>
            </tr>
            <tr>
              <th scope="col"
                ><div>{{ $t('admin.content') }}</div></th
              >
              <td colspan="3">
                <LangInput v-model="val.content"></LangInput>
              </td>
            </tr>
          </tbody>
        </table>
      </template>
      <div :class="$style.buttonArea">
        <span :class="[$style.button, $style.black, $style.xLarge]"
          ><input type="submit" accesskey="s" :value="$t('admin.save')"
        /></span>
      </div>
    </form>
  </AdminLayout>
</template>
